import { useGlobalStore } from '@highlight/ipc/react'
import { Button } from '@highlight/ui'
import { useUpdateState } from '@renderer/hooks/use-update-state'
import { Announcement } from '.'

export const UpdateAnnouncement = () => {
  const [automaticUpdates] = useGlobalStore<boolean>('settings', 'updates.automatic', true)
  const { update, labels, onClickCTA, onDismiss } = useUpdateState()

  if ((automaticUpdates && window.__RENDERER_NAME === 'overlay' && update?.state !== 'error') || !labels) {
    return null
  }

  return (
    <Announcement.Container className="bg-green/50 backdrop-blur-lg">
      <Announcement.Title>{labels?.title}</Announcement.Title>
      <Announcement.Actions>
        <Button
          variant="outline"
          size="sm"
          onClick={onClickCTA}
          disabled={update?.state === 'downloading' || update?.state === 'installing'}
        >
          {labels?.cta}
        </Button>
        <Button variant="ghost" size="sm" onClick={onDismiss}>
          Remind me later
        </Button>
      </Announcement.Actions>
    </Announcement.Container>
  )
}
